// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"00bc56ed","367":"e2174493","406":"1c5a96dc","909":"82c679fd"}[chunkId] + ".chunk.js";
};